module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 47
// module chunks = 0